import React from 'react'

import LogoProyecto from './../../UI/Logos/logo_proyecto.svg'

interface Props{
    isLoading: boolean
    isWelcome: boolean
    handleHideWelcome: any
}

interface State{}

class WelcomeScreen extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(){
        return(
            <div className={this.props.isLoading || this.props.isWelcome ? "welcome-container fade-out":"welcome-container fade-in"}>
                <div className='logo-proyecto-container'>
                    <img src={LogoProyecto}/>
                </div>
                <div className='text-container'>
                    <div className='legal-text'>
                    Este material es una representación artística, por lo tanto, los detalles del diseño, colores y especificaciones de materiales están sujetos a modificaciones durante el proceso de construcción. Las áreas son aproximadas, el mobiliario representado hace parte de los elementos decorativos de la representación gráfica y no comprometen al constructor
                    </div>
                </div>
                <div className='btn-ingreso' onClick={() => {this.props.handleHideWelcome()}}>Ingresar</div>
            </div>
        )
    }
}

export default WelcomeScreen